import ServiceBase from "base/baseService"

export default class GrupoVariavelService extends ServiceBase {

    title = "Grupo de variável"
    pluralTitle = "Grupos de variável"
    url = '/cadastro/outros/grupovariavel'
    frontUrl = '/cadastro/outros/grupovariavel'
    frontUrlList = '/cadastro/outros/grupovariavellist'
    primaryKey = 'codigo_gruv'

    prepareToFront(data = {}) {
        data.descricao_gruv = data?.descricao_gruv || ''
        return data
    }

    prepareToSave({ data }) {
        if ('meta' in data) delete data.meta
        return data
    }
}
